export default __webpack_public_path__ + "static/media/Spinner.099cacad.svg";